export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20flat%20lay%20composition%20with%20neatly%20arranged%20sneakers%2C%20soft%20cashmere%20sweater%2C%20leather%20accessories%20and%20minimalist%20perfume%20bottles%20on%20warm%20cream%20textured%20surface%2C%20editorial%20product%20photography%2C%20soft%20natural%20diffused%20lighting%20casting%20gentle%20shadows%2C%20terracotta%20and%20sand%20neutral%20palette%20with%20touches%20of%20sage%20green%2C%20sophisticated%20brand%20catalogue%20aesthetic%2C%20clean%20organized%20layout%2C%20high-end%20retail%20visual%20merchandising%20style%2C%20serene%20calm%20mood&width=1920&height=1080&seq=hero-product-lifestyle-warm-2026&orientation=landscape"
          alt="Hipobuy Sheet product collection lifestyle aesthetic"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full border border-background-50/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-sm text-background-50 font-medium">Updated 2026 Guide</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 leading-tight mb-6">
          The Ultimate <span className="text-primary-300">Hipobuy Sheet</span> Shopping Guide
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover, compare, and organize your shopping research with the most comprehensive Hipobuy Sheet resource. Browse 14 product categories, access detailed guides, and make smarter buying decisions — all in one place.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-base font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Hipobuy Sheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 text-base font-semibold rounded-full border border-background-50/30 hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 mt-12">
          {[
            { icon: 'ri-check-line', text: 'Updated Spreadsheet Resources' },
            { icon: 'ri-file-search-line', text: 'Independent Research Guides' },
            { icon: 'ri-scales-3-line', text: 'Product Comparison Tools' },
            { icon: 'ri-shield-check-line', text: 'Safety Knowledge Center' },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-background-50/80 text-sm">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-accent-300`}></i>
              </span>
              {badge.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}